import { Component, h, Host, Prop, State, Element, Method } from '@stencil/core';
import { CartIcon } from '../../types/types';
import { detectCheckout, getElementAttributes } from '../../utils/utils';

@Component({
  tag: 'rtr-checkout',
  shadow: true,
})
export class RtrCheckout {
  // it's only defined in order to make widget-config to show icon properly
  @Prop() customCartIcon: CartIcon = null;

  @State() idsOfCheckouts: string[];
  @State() checkoutId: string = (Math.random() + 1).toString(36).substring(2);

  @Element() el;
  container: HTMLElement;

  componentDidLoad() {
    this.idsOfCheckouts = detectCheckout();
  }

  @Method()
  async updateAccount(accessToken: string, onSuccess = () => null) {
    (this.container as any)?.updateAccount(accessToken, onSuccess);
  }

  get canRenderCheckout(): boolean {
    if (!this.idsOfCheckouts?.length) {
      return false;
    }

    // render only first checkout on the list
    return this.checkoutId === this.idsOfCheckouts[0];
  }

  render() {
    const properties = getElementAttributes(this.el.attributes, { class: true, ref: true, style: true });

    return (
      <Host id={this.checkoutId}>
        {this.canRenderCheckout && <rtr-checkout-controller {...properties} ref={el => (this.container = el as HTMLElement)} customCartIcon={this.customCartIcon} />}
      </Host>
    );
  }
}
